import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  RouteComponentProps,
  Redirect,
} from "react-router-dom";
import Layout from "./components/containers/Layout";
import LoginRequiredRoute from "./routes/LoginRequiredRoute";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import routes from "./routes";
import AppDataLoadedFirst from "./components/middleware/AppDataLoadedFirst";
import PermissionRequiredRoute from "./routes/PermissionRequiredRoute";
import PublicPortalPage from "./components/public-portal/PublicPortalPage";
import OauthConsentPage from "./pages/OauthConsentPage";

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

function AppRouter() {
  let routeComponents: React.ReactElement[] = [];
  for (const key in routes) {
    const route = routes[key];

    if (route.permissionName !== undefined) {
      routeComponents.push(
        <LoginRequiredRoute
          key={key}
          path={route.path}
          exact={route.exact}
          render={(props: RouteComponentProps) => (
            <AppDataLoadedFirst>
              <PermissionRequiredRoute
                permissionNames={
                  Array.isArray(route.permissionName!)
                    ? route.permissionName!
                    : [route.permissionName!]
                }
              >
                <Layout {...props} />
              </PermissionRequiredRoute>
            </AppDataLoadedFirst>
          )}
        />
      );
    } else {
      routeComponents.push(
        <LoginRequiredRoute
          key={key}
          path={route.path}
          exact={route.exact}
          render={(props: RouteComponentProps) => (
            <AppDataLoadedFirst>
              <Layout {...props} />
            </AppDataLoadedFirst>
          )}
        />
      );
    }
  }

  return (
    <Router>
      <React.Suspense fallback={loading}>
        <Switch>
          <Route path="/login" component={Login} />
          <Route path="/forgot-password" exact component={ForgotPassword} />
          <Route
            path="/reset-password/:token"
            exact
            component={ResetPassword}
          />
          <Route
            path="/consulta/:uniqueId"
            exact
            render={() => <PublicPortalPage />}
          />
          {/* Outside the Layout on purpose: there is no sidebar and no company
              selector here. The person is deciding about their account, and
              the screen has to read the same on a phone, which is where most
              of these are going to happen. */}
          <LoginRequiredRoute
            path="/oauth/consent"
            exact
            render={() => <OauthConsentPage />}
          />
          {routeComponents}
          <Redirect from="/" to="/dashboard" />
        </Switch>
      </React.Suspense>
    </Router>
  );
}

export default AppRouter;
